import { Dispatch, SetStateAction } from "react"

// ** Third Party Component
import axios from "axios"
import { parseCookies } from "nookies"
import axiosServices from "@pma/utils/axios"

// ** Routes
import {
  ADD_FILES_TO_NOTE_ENDPOINT,
  ADD_FILES_TO_PROJECT_ENDPOINT,
  ADD_FILES_TO_TASK_ENDPOINT,
  CREATE_FOLDER,
  DELETE_FILE_ENDPOINT,
  DELETE_FOLDER_ENDPOINT,
  DELETE_MULTIPLE_FILE_ENDPOINT,
  DIGITAL_OCEAN_FILES_ENDPOINT,
  FOLDER_ENDPOINT,
  FOLDER_RENAME_ENDPOINT,
  GET_FOLDER_AND_FILE_V2,
  GET_LATEST_FILES,
  MOVE_FILE_ENDPOINT,
  NEW_GET_ALL_FOLDERS_ENDPOINT,
} from "@pma/utils/api-routes"

// ** Constants
import { ACCESS_TOKEN } from "@pma/utils/constants"

export const getNewFileListService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .get(GET_LATEST_FILES, {
        params: {
          deleted: false,
          paging_start_page: data?.start_page,
          paging_per_page: 4,
          organization_id: data?.organization_id,
          uploaded_after: data?.uploaded_after,
        },
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const uploadMultipleFilesService = async (
  payload: any,
  setProgress: Dispatch<SetStateAction<number>>,
) => {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const response: any = await new Promise((resolve, reject) => {
    axios
      .post(`${DIGITAL_OCEAN_FILES_ENDPOINT}?token=${accessToken}`, payload, {
        headers: {
          accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress(progressEvent: any) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          setProgress(percentCompleted)
        },
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const uploadFilesInNoteService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(ADD_FILES_TO_NOTE_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const uploadFilesInTaskService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(ADD_FILES_TO_TASK_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const uploadFilesInProjectService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(ADD_FILES_TO_PROJECT_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getFolderListService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(NEW_GET_ALL_FOLDERS_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const createNewFolderService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(CREATE_FOLDER, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getFolderAndFileService = async (payload: any) => {
  const response = await axiosServices.post(FOLDER_ENDPOINT, payload)
  return response.data
}

export const deleteMultipleFilesService = async (payload: any) => {
  const response = await axiosServices.delete(DELETE_MULTIPLE_FILE_ENDPOINT, { data: payload })
  return response.data
}

export const deleteFolderService = async (folderId: number) => {
  const response = await axiosServices.delete(DELETE_FOLDER_ENDPOINT + `/${folderId}`)
  return response.data
}

export const deleteFileService = async (fileId: number) => {
  const response = await axiosServices.delete(DELETE_FILE_ENDPOINT + `/${fileId}`)
  return response.data
}

export const renameFolderService = async (payload: any) => {
  const response = await axiosServices.post(FOLDER_RENAME_ENDPOINT, payload)
  return response.data
}

export const getFolderAndFilesV2Service = async (payload: any) => {
  const response = await axiosServices.post(GET_FOLDER_AND_FILE_V2, payload)
  return response.data
}

export const moveFilesService = async (payload: any) => {
  const response = await axiosServices.post(MOVE_FILE_ENDPOINT, payload)
  return response.data
}

export const uploadFilesService = async (payload: any) => {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const response = await axios.post(
    `${DIGITAL_OCEAN_FILES_ENDPOINT}?token=${accessToken}`,
    payload,
    {
      headers: {
        accept: "*/*",
        "Content-Type": "multipart/form-data",
      },
    },
  )
  return response.data
}

export const uploadFilesInFolderService = async (payload: any) => {
  const response = await axiosServices.post(ADD_FILES_TO_PROJECT_ENDPOINT, payload)
  return response.data
}
